<template>
    
   <div>
        <img class="text-center align-middle h-100 mb-1 mr-1" :src="region === 'TN' ? require('@/assets/images/tunisia-flag.svg') : require('@/assets/images/CoteDIvoire-flag.png')"  >
                        
        <span class="font-size-14 font-weight-bold mr-2">Français </span>   
        
        <span style="border-bottom: 1px solid #121212;">
        <span class="font-size-14 font-weight-bold ">{{ region == 'TN' ? 'TND' : 'CFA' }} </span>  
        </span>   
   </div>

</template>

<script>
import SettingsApi from "@/services/settings-api";  

export default ({
    name: "footer-region",
    mounted(){
      this.getCurrentRegion()
    },

    methods:{
      getCurrentRegion(){
        SettingsApi.getCurrentRegion().then((region) => {
          if(region){
            this.region = region
          }
        })
      }
    },

    data() {
    return {

     region: 'TN',    
    }
  },

})
</script>


